<ng-container *ngIf="isAddResultDropdown">
<div class="result-cell d-flex align-items-center justify-content-center h-100 px-2 position-relative">
    <div ngbDropdown [placement]="['bottom', 'top']" container="body" [autoClose]="true">
        <button type="button" class="btn btn-sm btn-link ps-4 d-flex align-items-center gap-1 no-focus"
            ngbDropdownToggle (click)="$event.stopPropagation(); $event.preventDefault()">
            <svg id="more_4_" data-name="more (4)" xmlns="http://www.w3.org/2000/svg" width="15.264" height="15.264"
                viewBox="0 0 15.264 15.264">
                <g id="_x33_">
                    <path id="Path_1816" data-name="Path 1816"
                        d="M11.448,1.272a2.547,2.547,0,0,1,2.544,2.544v7.632a2.547,2.547,0,0,1-2.544,2.544H3.816a2.547,2.547,0,0,1-2.544-2.544V3.816A2.547,2.547,0,0,1,3.816,1.272Zm0-1.272H3.816A3.816,3.816,0,0,0,0,3.816v7.632a3.816,3.816,0,0,0,3.816,3.816h7.632a3.816,3.816,0,0,0,3.816-3.816V3.816A3.816,3.816,0,0,0,11.448,0Z"
                        fill="#4eabe1" />
                </g>
                <g id="_x32_" transform="translate(6.996 3.816)">
                    <path id="Path_1817" data-name="Path 1817"
                        d="M11.636,13.632A.636.636,0,0,1,11,13V6.636a.636.636,0,0,1,1.272,0V13A.636.636,0,0,1,11.636,13.632Z"
                        transform="translate(-11 -6)" fill="#4eabe1" />
                </g>
                <g id="_x31_" transform="translate(3.816 6.996)">
                    <path id="Path_1818" data-name="Path 1818"
                        d="M6,11.636A.636.636,0,0,1,6.636,11H13a.636.636,0,0,1,0,1.272H6.636A.636.636,0,0,1,6,11.636Z"
                        transform="translate(-6 -11)" fill="#4eabe1" />
                </g>
            </svg>
            <span class="label fw-medium text-decoration-underline">Add Result</span>
        </button>
 
        <div ngbDropdownMenu class="pt-2 pb-2 shadow dropdown-menu-right">
            <button ngbDropdownItem *ngFor="let item of menuItems" (click)="onMenuItemClick(item.action, $event)">
                {{ item.label }}
            </button>
        </div>
    </div>
</div>
</ng-container>

<ng-container *ngIf="isReadyStatusDropdown">
    <div class="d-flex align-items-center ms-2">
        <div ngbDropdown [placement]="['bottom-center', 'top-center']" [autoClose]="true">
            <button type="button" class="btn btn-sm btn-link d-flex align-items-center gap-1 no-focus px-2" ngbDropdownToggle
                (click)="$event.stopPropagation(); $event.preventDefault()">
                <span class="ready-label fw-medium pe-1">{{ value }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="12.619" height="7.082" viewBox="0 0 12.619 7.082">
                    <g id="Drop_arrow" data-name="Drop arrow" transform="translate(-419.709 -282.412)">
                        <g id="Iconly_Light_Arrow---Right-Circle" data-name="Iconly/Light/Arrow---Right-Circle"
                            transform="translate(431.268 283.473) rotate(90)">
                            <g id="Arrow---Right-Circle" transform="translate(0 10.498) rotate(-90)">
                                <path id="Stroke-3" d="M0,0,5.249,5.272,10.5,0" transform="translate(0)" fill="transparent" stroke="#646e76"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" fill-rule="evenodd" />
                            </g>
                        </g>
                    </g>
                </svg>
            </button>

            <div ngbDropdownMenu class="pt-2 pb-2 shadow line-status-dropdown">
                <button ngbDropdownItem *ngFor="let item of lineStatusOptions" class="" (click)="onLineStatusSelected(item.action)">
                    {{ item.label }}
                </button>
            </div>
        </div>
    </div>
</ng-container>
